import { dateFilter, toIntegerOrUndefined } from '@/utils'

import render from './render'

export default {
  name: 'Filters',

  mixins: [ dateFilter ],

  computed: {
    /**
     * Значения полей фильтра в меню кнопки фильтра по умолчанию для кнопки сброса.
     *
     * @returns {Object<string, undefined>} Пустое значение по имени поля.
     */
    defaultFilter() {
      return {
        status: undefined,
        customerId: undefined,
        ownerId: undefined,
        requisiteId: undefined,
        companyId: undefined
      }
    }
  },

  methods: {
    _outputFilter(result) {
      result.docNumber = toIntegerOrUndefined(result.docNumber)

      return result
    }
  },

  render
}
